import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { HttpHeadersService } from 'src/app/core/shared-service/http-headers.service';
import { IDownloadSoftwareResponse, ISoftwareDownloadVO } from 'src/app/post-login/services/software.service.model';
import { environment } from 'src/environments/environment';
import { CONSOLE_GROUPS_DATA } from './download-software.data';
import { IDownloadSoftwareModel, ISoftwareDownloadConsoleTypes } from './download-software.interface';

@Injectable({
  providedIn: 'root',
})
export class SoftwareDownloadService {
  constructor(
    private httpClient: HttpClient,
    private httpHeaderService: HttpHeadersService
  ) {}

  getDownloadSoftware(): Observable<IDownloadSoftwareModel[]> {
    const headers = this.httpHeaderService.preLoginHttpAuthorizationHeader();
    return this.httpClient
      .get<IDownloadSoftwareResponse>(environment.servicePath + '/software_update/get_download_software', { headers })
      .pipe(
        take(1),
        map((data) => this.transformData(data))
      );
  }

  private transformData(dataOld: IDownloadSoftwareResponse): IDownloadSoftwareModel[] {
    return CONSOLE_GROUPS_DATA.map((data) => {
      const group = { ...data };
      group.consoleTypes.forEach((console) => {
        this.checkHideConsole(console);
        if (!group.officialSoftware.url) {
          const consoleType = dataOld.softwareDownloadVO.find(
            (x: ISoftwareDownloadVO) => x.consoleType == console.consoleType
          );

          if (consoleType && consoleType.hasSoftwareRelease == 'true') {
            let version = consoleType.latestSoftwareVersion;
            if (version?.length < 6) version = String(consoleType.latestSoftwareVersion).padStart(6, '0');
            version = `${parseInt(version?.substring(1, 2))}.${parseInt(version?.substring(2, 4))}.${parseInt(
              version?.substring(4)
            )}`;

            group.officialSoftware.version = version;
            group.officialSoftware.url = consoleType.url.toString();
          } else console.hidden = true;
        }
        group.consoleTypes = group.consoleTypes.filter((c) => !c.hidden);
        group.hidden = group.consoleTypes.length == 0;
      });
      return group;
    }).filter((g) => !g.hidden);
  }

  private checkHideConsole(console: ISoftwareDownloadConsoleTypes): void {
    const hiddenConsolesInProd = [''];
    if (hiddenConsolesInProd.includes(console.consoleType) && environment.production) console.hidden = true;
  }
}
